import { render, staticRenderFns } from "./dates-page.vue?vue&type=template&id=6d5a7ab0"
import script from "./dates-page.vue?vue&type=script&lang=js"
export * from "./dates-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports